import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'

/** @param {ShiftPreset} shiftPreset */
export const createSectorShiftPreset = (user, sector, shiftPreset) => {
  return apiClient.post(user, `api/sectors/${getIdOrNull(sector)}/shift-presets`, shiftPreset.toRequestBody())
}

/** @param {ShiftPreset} shiftPreset */
export const updateShiftPreset = (user, shiftPreset) => {
  return apiClient.patch(user, `api/shift-presets/${getIdOrNull(shiftPreset)}`, shiftPreset.toRequestBody())
}

export const getAllShiftPresets = (user, parameters = {}) => {
  return requestWithPromise(
    `/api/shift-presets${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}
